import { navItems } from './navItems'

function matchesPath(
  href: string,
  prefix: string,
  pathname: string,
  search: string,
): boolean {
  if (href.includes('?')) {
    const [path, query] = href.split('?', 2)
    return pathname === `${prefix}${path}` && search === `?${query}`
  }
  const full = `${prefix}${href}`
  return pathname === full || pathname.startsWith(full + '/')
}

export function navItemIsActive(args: {
  href: string
  children?: { href: string }[]
  prefix: string
  pathname: string
  search: string
}): boolean {
  const { href, children, prefix, pathname, search } = args
  if (matchesPath(href, prefix, pathname, search)) {
    // Yield to a query-param sibling if it currently owns this URL
    return !navItems.some((item) => {
      if (!item.href.startsWith(href + '?')) return false
      const [, query] = item.href.split('?', 2)
      return search === `?${query}`
    })
  }
  return Boolean(children?.some((child) => matchesPath(child.href, prefix, pathname, search)))
}

export function navChildIsActive(args: {
  childHref: string
  siblings: { href: string }[]
  prefix: string
  pathname: string
  search: string
}): boolean {
  const { childHref, siblings, prefix, pathname, search } = args
  if (childHref.includes('?')) {
    const [path, query] = childHref.split('?', 2)
    return pathname === `${prefix}${path}` && search === `?${query}`
  }
  const full = `${prefix}${childHref}`
  if (!(pathname === full || pathname.startsWith(full + '/'))) return false
  return !siblings.some(
    (sibling) =>
      sibling.href !== childHref &&
      sibling.href.length > childHref.length &&
      (pathname === `${prefix}${sibling.href}` || pathname.startsWith(`${prefix}${sibling.href}/`)),
  )
}
